import styled from 'styled-components';

export const SelectWrapper = styled.div`
  margin-top: 24px;
`;

export const Select = styled.select`
  font-family: 'Spectral-Regular', serif;
  padding: 0.75rem;
  padding-right: 2rem;
  border: 1px solid #283618;
  font-size: 0.875rem;
  color: #283618;
  width: ${(props) => (props.fullWidth ? '100%' : '120px')};
  background-color: white;
  cursor: pointer;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%23283618' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 0.75rem center;

  option {
    color: #283618;
  }

  option:first-child {
    color: #283618;
    opacity: 0.5;
  }

  &:focus {
    outline: none;
    border-color: #283618;
  }
`;
